module.exports = __webpack_public_path__ + "img/image21.16e1350b.jpg";